import { render, staticRenderFns } from "./Masters2023.vue?vue&type=template&id=46402274&scoped=true"
import script from "./Masters2023.vue?vue&type=script&lang=js"
export * from "./Masters2023.vue?vue&type=script&lang=js"
import style0 from "./Masters2023.vue?vue&type=style&index=0&id=46402274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46402274",
  null
  
)

export default component.exports